import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useDebouncedEffect } from "@react-hookz/web";
import { useEffect, useState } from "react";

interface IProps {
    /**
     * Whether the input is disabled
     */
    disabled?: boolean;
    search: string;
    setSearch: (search: string) => void;
    /**
     * Debounce delay in milliseconds (default: 300)
     */
    debounceMs?: number;
}

/**
 * Input field to search by topic or field (v2) or by clause or field (v1)
 */
export const SearchBar = ({
    disabled = false,
    search,
    setSearch,
    debounceMs = 300,
}: IProps) => {
    const [localSearch, setLocalSearch] = useState(search);

    // Sync local state when the search prop changes (e.g., when switching tabs)
    useEffect(() => {
        setLocalSearch(search);
    }, [search]);

    useDebouncedEffect(
        () => {
            setSearch(localSearch);
        },
        [localSearch],
        debounceMs
    );

    const handleClear = () => {
        setLocalSearch("");
        setSearch("");
    };

    return (
        <TextField
            placeholder={"Search..."}
            fullWidth
            size="small"
            disabled={disabled}
            value={localSearch}
            onChange={(event) => setLocalSearch(event.target.value)}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon sx={{ width: 18, height: 18 }} />
                        </InputAdornment>
                    ),
                    endAdornment: localSearch && (
                        <InputAdornment position="end">
                            <IconButton onClick={handleClear} size="small">
                                <ClearIcon sx={{ width: 18, height: 18 }} />
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            }}
        />
    );
};
